import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Icon } from 'assets/icons';
import { setPageTitle } from 'store/actions/header';
import { Spacer } from 'app/member/layouts/generic';
import { GridColumn, GridRow } from 'app/member/layouts/grid';
import { GenerateWordSearchButton } from './generate';
import { WordSearchList } from './list';
import { WordSearchViewPage } from './view';
import styles from './word-searches.module.css';

export const WordSearchesView = () => {
  const dispatch = useDispatch();

  const [selected_id, setSelectedId] = useState(null);
  const [refresh_key, setRefreshKey] = useState(0);
  const [is_refreshing, setIsRefreshing] = useState(false);

  useEffect(() => {
    dispatch(setPageTitle([{ title: 'Content', path: '.' }]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRefresh = () => {
    if (is_refreshing) return;

    setIsRefreshing(true);
    setRefreshKey((key) => key + 1);
  };

  const handleGenerated = (word_search_id) => {
    setSelectedId(word_search_id);
    setRefreshKey((key) => key + 1);
  };

  return (
    <>
      <GridRow num_of_columns={2}>
        <GridColumn span={1}>
          <p className={styles.toolbarHint}>
            Themed word-search puzzles rendered as PNG images, with the answer key kept on record.
          </p>
        </GridColumn>
        <GridColumn span={1}>
          <div className={styles.toolbarActions}>
            <button
              type="button"
              className={styles.refreshBtn}
              onClick={handleRefresh}
              disabled={is_refreshing}
              title="Reload the word search list"
            >
              <span className={is_refreshing ? styles.refreshIconSpinning : styles.refreshIcon}>
                <Icon name="refresh" width={15} height={15} />
              </span>
              <span>{is_refreshing ? 'Refreshing…' : 'Refresh'}</span>
            </button>
            <GenerateWordSearchButton onGenerated={handleGenerated} />
          </div>
        </GridColumn>
      </GridRow>
      <Spacer multiple={3} />

      <div className={styles.layout}>
        <div className={styles.listPane}>
          <WordSearchList
            selected_id={selected_id}
            refresh_key={refresh_key}
            onSelect={setSelectedId}
            onRefreshComplete={() => setIsRefreshing(false)}
          />
        </div>
        <div className={styles.previewPane}>
          {selected_id ? (
            <WordSearchViewPage
              word_search_id={selected_id}
              onDelete={() => {
                setSelectedId(null);
                setRefreshKey((key) => key + 1);
              }}
            />
          ) : (
            <div className={styles.emptyState}>
              <div className={styles.emptyIcon}>
                <Icon name="board_view" width={22} height={22} />
              </div>
              <p className={styles.emptyTitle}>No word search selected</p>
              <p className={styles.emptyHint}>
                Select a word search from the list, or generate a new one.
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
